import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@material-ui/core";
import { Close, Description } from "@mui/icons-material";
import DocumentPreview from "components/_refactor/document-preview";

export default function DialogPreviewDocument({ open, onClose, selectedRow }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg">
      <DialogTitle>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h3" color="primary">
            <Description style={{ marginRight: "12px" }} />
            {selectedRow?.NomeOriginal || "Visualizar Documento"}
          </Typography>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </div>
      </DialogTitle>

      <DialogContent dividers>
        <DocumentPreview url={selectedRow?.UrlArquivo} />
      </DialogContent>

      <DialogActions>
        <Button
          onClick={() => {
            window.open(selectedRow?.UrlArquivo, "_blank");
          }}
          download={selectedRow?.NomeOriginal || true}
          variant="contained"
          disabled={!selectedRow?.UrlArquivo}
        >
          Download
        </Button>
        <Button onClick={onClose} variant="outlinedPrimary">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
